let validateEmailControlTimer;
let validatePasswordControlTimer;

$(document).ready(function () {
	'use strict';

	if ($('#frm-signInForm').length === 0) {
		return;
	}

	let emailValidationXhr = undefined;
	let step = 1;

	// Validation of email input
	let validateEmailControl = function () {
		if (step !== 1) {
			return;
		}

		let $inputEmail = $(this);

		clearTimeout(validateEmailControlTimer);
		clearTimeout(Nette.validateControlTimer[$inputEmail.attr('id')]);

		validateEmailControlTimer = setTimeout(function () {
			if (!Nette.validateControl($inputEmail[0])) {
				return;
			}

			validateEmailControlByXhr($inputEmail);
		}, 250);
	};

	let validateEmailControlByXhr = function ($inputEmail, callback = null) {
		if (emailValidationXhr && emailValidationXhr.readyState !== 4) {
			emailValidationXhr.abort();
		}

		emailValidationXhr = $.post($inputEmail.data('ajax-action-email-validation'), {email: $inputEmail.val()}, function (response) {
			if (response.redirect !== undefined) {
				location.href = response.redirect;

				return;
			}

			let $smartInputEmail = $inputEmail.parents('smart-input');
			let $smartInputEmailErrorMessage = $smartInputEmail.find('smart-input-error-message');

			if (response.state === 'error') {
				$inputEmail.addClass('error').data('error-message', response.message);
				$smartInputEmail.addClass('error');

				if ($smartInputEmailErrorMessage.length) {
					$smartInputEmailErrorMessage.html(response.message);
				}
				else {
					$smartInputEmail.append('<smart-input-error-message>' + response.message + '</smart-input-error-message>');
				}
			}
			else {
				$smartInputEmail.find('[data-error-message]').removeAttr();
				$smartInputEmail.find('smart-input-error-message').remove();
				$smartInputEmail.removeClass('error').find('.error').removeClass('error');
			}

			if (response.resendCustomerWelcomeEmail && response.resendCustomerWelcomeEmail === true) {
				$('#resendCustomerWelcomeEmailWrapper').removeAttr('hidden');
			}
			else {
				$('#resendCustomerWelcomeEmailWrapper').attr('hidden', true);
			}

			if (callback !== null && callback !== undefined) {
				callback(response);
			}
		});
	};

	$(document).on('keyup', 'input#frm-signInForm-email.blured', validateEmailControl);
	$(document).on('blur', 'input#frm-signInForm-email', validateEmailControl);

	// Continue to step 2
	let continueToStep2 = function () {
		if (step !== 1) {
			return;
		}

		let $inputEmail = $('#frm-signInForm-email');

		clearTimeout(validateEmailControlTimer);
		clearTimeout(Nette.validateControlTimer[$inputEmail.attr('id')]);

		// Partial validation
		if (!Nette.validateControl($inputEmail[0])) {
			$.flashMessenger.createFlashMessage($inputEmail.data('error-message'), 'error', 5000);

			return;
		}

		validateEmailControlByXhr($inputEmail, function (response) {
			if (response.state === 'error') {
				$.flashMessenger.createFlashMessage($inputEmail.data('error-message'), 'error', 5000);
				$inputEmail.focus();

				return;
			}

			// Show step 2
			step = 2;
			$('#signInStep1').attr('hidden', true);
			$('#signInStep2').removeAttr('hidden').addClass('showSignInStep2');
			$('#customerName').html(response.name);
			$('#customerEmail').html(response.email);
			$('#frm-signInForm-password').focus();
		});
	};

	$(document).on('keydown', 'input#frm-signInForm-email', function (event) {
		let keyCode = event.which || event.keyCode;

		clearTimeout(validateEmailControlTimer);
		clearTimeout(Nette.validateControlTimer[$(this).attr('id')]);

		if (keyCode === 13) {
			event.preventDefault();
		}
	});

	$(document).on('keyup', 'input#frm-signInForm-email', function (event) {
		let keyCode = event.which || event.keyCode;

		if (keyCode === 13) {
			continueToStep2();
			event.stopPropagation();
		}
	});

	$('#signInContinue').click(function () {
		continueToStep2();

		return false;
	});

	// Resend customer welcome email
	let resendCustomerWelcomeEmailXhr = undefined;

	$('#resendCustomerWelcomeEmail').click(function () {
		if (resendCustomerWelcomeEmailXhr && resendCustomerWelcomeEmailXhr.readyState !== 4) {
			resendCustomerWelcomeEmailXhr.abort();
		}

		let data = {email: $('#frm-signInForm-email').val(), _do: 'signResendCustomerWelcomeEmailForm-submit'};

		resendCustomerWelcomeEmailXhr = $.post($(this).attr('href'), data, function (response) {
			if (response.redirect !== undefined) {
				location.href = response.redirect;

				return;
			}

			$.flashMessenger.createFlashMessage(response.message, response.state, 5000);
		});

		return false;
	});

	// Password ========================================================================================================
	let passwordValidationXhr = undefined;

	// Validation of password input
	let validatePasswordControl = function () {
		if (step !== 2) {
			return;
		}

		let $inputPassword = $(this);

		clearTimeout(validatePasswordControlTimer);
		clearTimeout(Nette.validateControlTimer[$inputPassword.attr('id')]);

		validatePasswordControlTimer = setTimeout(function () {
			if (!Nette.validateControl($inputPassword[0])) {
				return;
			}

			validatePasswordControlByXhr($('#frm-signInForm-email'), $inputPassword);
		}, 250);
	};

	let validatePasswordControlByXhr = function ($inputEmail, $inputPassword, callback = null) {
		if (passwordValidationXhr && passwordValidationXhr.readyState !== 4) {
			passwordValidationXhr.abort();
		}

		let data = {email: $inputEmail.val(), password: $inputPassword.val()};
		passwordValidationXhr = $.post($inputPassword.data('ajax-action-password-validation'), data, function (response) {
			if (response.redirect !== undefined) {
				location.href = response.redirect;

				return;
			}

			let $smartInputPassword = $inputPassword.parents('smart-input');
			let $smartInputPasswordErrorMessage = $smartInputPassword.find('smart-input-error-message');

			if (response.state === 'error') {

				$inputPassword.addClass('error').data('error-message', response.message);
				$smartInputPassword.addClass('error');

				if ($smartInputPasswordErrorMessage.length) {
					$smartInputPasswordErrorMessage.html(response.message);
				}
				else {
					$smartInputPassword.append('<smart-input-error-message>' + response.message + '</smart-input-error-message>');
				}

				// change by Issue DEVONE-158
				// $('#resetPasswordWrapper').removeAttr('hidden');
				// $('#backToStep1Wrapper').removeAttr('hidden');
			}
			else {
				$smartInputPassword.find('[data-error-message]').removeAttr();
				$smartInputPassword.find('smart-input-error-message').remove();
				$smartInputPassword.removeClass('error').find('.error').removeClass('error');
				// change by Issue DEVONE-158
				// $('#resetPasswordWrapper').attr('hidden', true);
				// $('#backToStep1Wrapper').attr('hidden', true);
			}

			if (callback !== null && callback !== undefined) {
				callback(response);
			}
		});
	};

	$(document).on('keyup', 'input#frm-signInForm-password.blured', validatePasswordControl);
	$(document).on('blur', 'input#frm-signInForm-password', validatePasswordControl);

	$('#resetPassword').click(function () {
		clearTimeout(validatePasswordControlTimer);
		clearTimeout(Nette.validateControlTimer[$('#frm-signInForm-password').attr('id')]);
	});

	$('#backToStep1').click(function () {
		clearTimeout(validatePasswordControlTimer);
		clearTimeout(Nette.validateControlTimer[$('#frm-signInForm-password').attr('id')]);

		$('#signInStep2').attr('hidden', true).removeClass('showSignInStep2');
		$('#signInStep1').removeAttr('hidden');
		step = 1;

		let $inputPassword = $('#frm-signInForm-password');
		let $smartInputPassword = $inputPassword.parents('smart-input');

		$smartInputPassword.find('[data-error-message]').removeAttr();
		$smartInputPassword.find('smart-input-error-message').remove();
		$smartInputPassword.removeClass('error').find('.error').removeClass('error');
		// change by Issue DEVONE-158
		// $('#resetPasswordWrapper').attr('hidden', true);
		// $('#backToStep1Wrapper').attr('hidden', true);
		$('#frm-signInForm-email').val('').focus();

		return false;
	});

	// Step 2
	let sendForm = function () {
		if (step !== 2) {
			return;
		}

		let $inputEmail = $('#frm-signInForm-email');
		let $inputPassword = $('#frm-signInForm-password');

		clearTimeout(validatePasswordControlTimer);
		clearTimeout(Nette.validateControlTimer[$inputPassword.attr('id')]);

		// Partial validation
		if (!Nette.validateControl($inputPassword[0])) {
			$.flashMessenger.createFlashMessage($inputPassword.data('error-message'), 'error', 5000);

			return;
		}

		validatePasswordControlByXhr($inputEmail, $inputPassword, function (response) {
			if (response.state === 'error') {
				$.flashMessenger.createFlashMessage($inputPassword.data('error-message'), 'error', 5000);
				$inputPassword.focus();

				return;
			}

			// Submit form
			$('#frm-signInForm').submit();
		});
	};

	$(document).on('keydown', 'input#frm-signInForm-password', function (event) {
		let keyCode = event.which || event.keyCode;

		if (keyCode === 13) {
			event.stopPropagation();
			event.preventDefault();
		}
	});

	$(document).on('keyup', 'input#frm-signInForm-password', function (event) {
		let keyCode = event.which || event.keyCode;

		if (keyCode === 13) {
			sendForm();
			event.stopPropagation();
			event.preventDefault();
		}
	});

	$('#frm-signInForm input[type=submit]').click(function () {
		sendForm();

		return false;
	});

	// Reset password
	let resetPasswordXhr = undefined;

	$('#resetPassword').click(function () {
		if (resetPasswordXhr && resetPasswordXhr.readyState !== 4) {
			resetPasswordXhr.abort();
		}

		let data = {email: $('#frm-signInForm-email').val(), _do: 'resetPasswordForm-submit'};

		resetPasswordXhr = $.post($(this).attr('href'), data, function (response) {
			if (response.redirect !== undefined) {
				location.href = response.redirect;

				return;
			}

			$.flashMessenger.createFlashMessage(response.message, response.state, 5000);
		});

		return false;
	});
});
